import { createApiClient } from '@repo/api-client';

import { http } from './http';

/**
 * The single instance of the API contract, wired onto this app's transport.
 *
 * `@repo/api-client` knows neither the base URL, nor the token, nor Capacitor:
 * it simply receives an `HttpClient`. Every platform specific stays here, in
 * `lib/`.
 */
export const api = createApiClient(http);
